export default __webpack_public_path__ + "static/media/nossas_unidades_7.8e31a41a.webp";